const normalizePhone = (value, previousValue) => {
  console.log('test')
  if (!value) {
    return value
  }

  if (value.length > 17) {
    return previousValue;
  }
  let onlyNums = formatPhone(value, previousValue);
  let lastchar = onlyNums.charAt(onlyNums.length - 1)
  while (lastchar == '-' || lastchar == ')' || lastchar == ' ') {
    onlyNums = onlyNums.slice(0, onlyNums.length - 1);
    lastchar = onlyNums.charAt(onlyNums.length - 1);
  }
  return onlyNums
  // if (!previousValue || value.length > previousValue.length) {
  //   // typing forward


  //   if(onlyNums.length > 17) {
  //     return onlyNums.slice(0,17);
  //   }

  //   if(onlyNums.length <= 4) {
  //     if(onlyNums.length == 1) {
  //       if(onlyNums.charAt(0) == '+') {
  //         return '+1 (';
  //       }
  //     }
  //     return '+1 (' + onlyNums.slice(onlyNums.length - 1,onlyNums.length)
  //   }

  //   if (onlyNums.length === 7) {
  //     return onlyNums + ') '
  //   }

  //   if(onlyNums.length === 8 && onlyNums[8] != NaN) {
  //     return onlyNums.slice(0, 7) + ') ' + onlyNums.slice(7,8)
  //   }

  //   if(onlyNums.length === 9 && onlyNums[9] != NaN) {
  //     return onlyNums.slice(0, 8) + ' ' + onlyNums.slice(8,9)
  //   }

  //   if (onlyNums.length === 12) {
  //     return onlyNums + '-'
  //   }

  //   if (onlyNums.length === 13 && onlyNums[13] != NaN) {
  //     return onlyNums.slice(0, 12) + '-' + onlyNums.slice(12,13)
  //   }
  // } else if(!previousValue || value.length <= previousValue.length) {
  //   let position = findFirstDiffPos(value, previousValue);
  //   switch(position){
  //     case 0:case 1:case 2:case 3:case 7:case 8:case 12:
  //       if(position < 4 && previousValue.length > value.length && previousValue.length <= position) {
  //         return ""
  //       }
  //       if(position != previousValue.length-1)
  //         return previousValue
  //       else
  //         return onlyNums
  //     case 4:
  //       if(position == previousValue.length-1)
  //         return ""
  //     case 5:case 6:case 9:case 10: case 11: case 12: case 13:
  //       if(position != previousValue.length-1) {
  //         let test = formatPhone(value);
  //         let lastchar = test.charAt(test.length-1)
  //         while(lastchar == '-' || lastchar == ')' || lastchar == ' ') {
  //           test = test.slice(0,test.length-1);
  //           lastchar = test.charAt(test.length-1);
  //         }
  //         return test;
  //       } else {
  //         return onlyNums
  //       }
  //     default:
  //       return onlyNums

  //   }
  // }
  // if (onlyNums.length <= 18) {
  //   return onlyNums
  // }
}

const findFirstDiffPos = (a, b) => {
  var shorterLength = Math.min(a.length, b.length);

  for (var i = 0; i < shorterLength; i++) {
    if (a[i] !== b[i]) return i;
  }

  if (a.length !== b.length) return shorterLength;

  return -1;
}

export const formatPhone = (value, previousValue) => {
  if (!value) {
    return value
  }

  let test = value.replace(/[^\d]/g, '');
  let $1 = '';
  let $2 = '';
  if (test.length >= 11) {
    $1 = ') ';
    $2 = '-';
  } else {
    // $1 = value.length > 8 && test.length > 3 || value.length == 7 ? ') ' : '';
    // $2 = value.length > 13 && test.length > 6 || value.length == 12 ? '-' : '';
    $1 = value.length >= 7 && (value.length != 8 || value.charAt(7) != ')') ? ') ' : '';
    $2 = value.length > 12 ? '-' : '';
  }
  let includeOne = test.charAt(0) == 1 && test.length == 11;
  if(includeOne) {
    return '+1 (' + test.slice(1, 4) + $1 + test.slice(4, 7) + $2 + test.slice(7, 11);
  } else {
    return '+1 (' + test.slice(0, 3) + $1 + test.slice(3, 6) + $2 + test.slice(6, 10);    
  }
}

export default normalizePhone;


// WEBPACK FOOTER //
// ./util/normalizePhone.js